import { Instance } from "../../Base";
import Decorator from "../Decorator";

export default class RequiredDecorator extends Decorator {
  constructor(component: Instance, marker: string, classes: string[] = []) {
    super(component);
    const element = document.createElement("span");
    element.classList.add(...classes);
    element.innerHTML = marker;
    this.component.element.appendChild(element);
  }
}
